import {ReportedError, ErrorCatalogId} from "../Types.ts";
import {CURRENT_REGION} from "../utils/region";
import jsonApi from "./jsonApi.ts";

export async function listInCatalog(catalogId: ErrorCatalogId) {
  return await jsonApi.get<ReportedError[]>(
    `/region/${CURRENT_REGION}/api/reported_error_catalogs/${catalogId}/errors`,
  );
}
